import React, { useState } from "react";
import {
	FooterContent,
	FooterContentInner,
	FooterContentSEO,
	FooterDescription,
	FooterDescriptionHeader,
	FooterDescriptionHeaderv2,
	FooterDescriptionMainHeader,
	FooterDescriptionMainHeaderA,
	FooterDescriptionMainHeaderImg,
	FooterDescriptionMainHeaderv2,
	FooterDescriptionv2,
	FooterIconItem,
	FooterIconItemA,
	FooterIconItemImg,
	FooterIconItemv2,
	FooterIcons,
	FooterIconsv2,
	FooterQuickLink,
	FooterQuickLinkGroup,
	FooterQuickLinkHeader,
	FooterQuickLinkHeaderv2,
	FooterQuickLinkItem,
	FooterQuickLinkItemA,
	FooterQuickLinkItemv3,
	FooterWrapper,
	FooterWrapperv2,
	Footerv3RegisterforBCT,
	Footerv3RegisterforBCTImg,
	Footerv3RegisterforBCTImgv2,
	Footerv3RegisterforBCTv2,
} from "./StyledFooterv2";
import { TranslateLabels, useLanguage } from "../content/MultiLanguge";
import { useLocation } from "react-router";
export default function Footer() {
	const { lang } = useLanguage();
	const { pathname, search } = useLocation();
	const howItWorksAnchor = "/#how-it-works";

	const handleHowItWorksClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
		if (pathname !== "/") return;

		event.preventDefault();
		const target = document.getElementById("how-it-works");
		if (!target) return;

		target.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});

		if (window.location.hash !== "#how-it-works") {
			window.history.replaceState(null, "", howItWorksAnchor);
		}
	};

	return (
		<>
			{pathname == "/find-location" || pathname == "/find-location/" ? (
				""
			) : (
				<FooterWrapperv2>
					<FooterContentInner>
						<FooterContent>
							<FooterDescriptionv2>
								<FooterDescriptionMainHeaderv2>
									<FooterDescriptionMainHeaderA>
										<FooterDescriptionMainHeaderImg
											src="./static/img/LogoWhite.png"
											alt={TranslateLabels[lang]?.ALT_MENU_LOGO}
										/>
									</FooterDescriptionMainHeaderA>
								</FooterDescriptionMainHeaderv2>
								<Footerv3RegisterforBCTv2>
									<FooterIconItemA
										href="https://www.facebook.com/whalelo"
										target="_blank"
										rel="noreferrer">
										<FooterIconItemv2>
											<FooterIconItemImg
												src="./static/img/fbft.png"
												alt={TranslateLabels[lang]?.ALT_GLOW_FAGE_FACE}
											/>
										</FooterIconItemv2>
									</FooterIconItemA>
									<FooterIconItemA
										href="https://www.instagram.com/whalelo.luggagestorage/"
										target="_blank"
										rel="noreferrer">
										<FooterIconItemv2>
											<FooterIconItemImg
												src="./static/img/itft.png"
												alt={TranslateLabels[lang]?.ALT_GLOW_FAGE_INSTA || "Instagram icon"}
											/>
										</FooterIconItemv2>
									</FooterIconItemA>
									<FooterIconItemA
										href="https://linkedin.com/company/whalelo-luggage-storage-delivery"
										target="_blank"
										rel="noreferrer">
										<FooterIconItemv2>
											<FooterIconItemImg
												src="./static/img/icon-linkedin.png"
												alt={TranslateLabels[lang]?.ALT_GLOW_FAGE_YOUTUBE || "LinkedIn icon"}
											/>
										</FooterIconItemv2>
									</FooterIconItemA>
								</Footerv3RegisterforBCTv2>
							</FooterDescriptionv2>
							<FooterQuickLinkGroup>
								<FooterQuickLink>
									<FooterQuickLinkHeaderv2>WhaleLO Luggage Storage</FooterQuickLinkHeaderv2>
									<FooterQuickLinkItemA to="/about">
										<FooterQuickLinkItemv3>About us</FooterQuickLinkItemv3>
									</FooterQuickLinkItemA>
									<FooterQuickLinkItemA to="/about">
										<FooterQuickLinkItemv3>Become A Partner</FooterQuickLinkItemv3>
									</FooterQuickLinkItemA>
									<FooterQuickLinkItemA to="/destinations">
										<FooterQuickLinkItemv3>All destinations</FooterQuickLinkItemv3>
									</FooterQuickLinkItemA>
								</FooterQuickLink>
								<FooterQuickLink>
									<FooterQuickLinkHeaderv2>Support</FooterQuickLinkHeaderv2>
									<FooterQuickLinkItemA
										to={howItWorksAnchor}
										onClick={handleHowItWorksClick}>
										<FooterQuickLinkItemv3>How it works</FooterQuickLinkItemv3>
									</FooterQuickLinkItemA>
									<FooterQuickLinkItemA to="/about">
										<FooterQuickLinkItemv3>FAQ</FooterQuickLinkItemv3>
									</FooterQuickLinkItemA>
									<FooterQuickLinkItemA to="/contact">
										<FooterQuickLinkItemv3>Contact us</FooterQuickLinkItemv3>
									</FooterQuickLinkItemA>
									<FooterQuickLinkItemA to="/term-of-use">
										<FooterQuickLinkItemv3>Term of Use</FooterQuickLinkItemv3>
									</FooterQuickLinkItemA>
								</FooterQuickLink>
							</FooterQuickLinkGroup>
						</FooterContent>
					</FooterContentInner>
				</FooterWrapperv2>
			)}
		</>
	);
}
